export const TELEGRAMS = 'TELEGRAMS';
export const AIRPORT_DOCUMENTS = 'AIRPORT_DOCUMENTS';
export const LIMITATIONS = 'LIMITATIONS';

export const initialState = {
    [TELEGRAMS]: true,
    [AIRPORT_DOCUMENTS]: true,
    [LIMITATIONS]: true,
};
